module.exports = __webpack_public_path__ + "img/wj.d0917992.png";